import React from 'react';
import bem from 'utils/bem';

const { block, el } = bem('specialist-teaser');

const SpecialistTeaser = ({ name, selectSpecialist }) => {
    const onClick = (e) => {
        e.preventDefault();
        selectSpecialist(name);
    }

    return (
        <div className={block()}>
            <div>{name}</div>
            <button onClick={onClick}>Выбрать специалиста</button>
        </div>
    )
}

export { FormSpecialistTeaser } from './FormSpecialistTeaser';
export { Short3RowsTeaser } from './Short3RowsTeaser';
export { Short2RowsTeaser } from './Short2RowsTeaser';
export { FrontSpecialistTeaser } from './FrontSpecialistTeaser';
export { FullSpecialistTeaser } from './FullSpecialistTeaser';
export { FixedSpecialistTeaser } from './FixedSpecialistTeaser';

export default SpecialistTeaser;
